import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  link: {
    borderRight: "solid 1px #999",
    marginRight: 10,
    paddingRight: 10
  },
  hideFooter: {
    marginRight: "240px"
  }
}));

export default useStyles;
